import { Incident, IncidentStatusCode } from '../models/incident.model';
import { PaginatedResponse } from '../models/paginated-response.model';

export type MockPaginatedResponse = PaginatedResponse & {pageId: string}

export const MOCK_INCIDENTS: Record<string, Incident[]> = {
  'PB9SE6X': [
    {
      pagerDutyIncidentId: 'INC001',
      pagerDutyServiceId: 'PB9SE6X',
      incidentStatusCode: IncidentStatusCode.ONGOING,
      priorityCode: 'P1',
      incidentEnvironmentCode: 'PROD',
      incidentStartDateTime: '2025-08-06T08:30:00Z',
      incidentDescription: 'Critical service outage affecting AVC View application',
      serviceIntegrationManagementTicketId: 'SIM-12345',
      incidentCommunicationCounter: 3,
      lastUpdateDateTime: '2025-08-06T09:45:00Z',
      lastUpdatedby: 'john.doe@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: '4f086099-caed-464e-95ab-2ac1189c89e9'
        }
      ]
    },
    {
      pagerDutyIncidentId: 'INC002',
      pagerDutyServiceId: 'PB9SE6X',
      incidentStatusCode: IncidentStatusCode.ONGOING,
      priorityCode: 'P2',
      incidentEnvironmentCode: 'UATR',
      incidentStartDateTime: '2025-09-07T10:15:00Z',
      incidentDescription: 'Performance degradation in authentication service',
      serviceIntegrationManagementTicketId: 'SIM-12346',
      incidentCommunicationCounter: 1,
      lastUpdateDateTime: '2025-09-07T11:00:00Z',
      lastUpdatedby: 'jane.smith@eulerhermes.com',
      impactedApplications: [
        {
          applicationId: '4f086099-caed-464e-95ab-2ac1189c89e9'
        }
      ]
    }
  ],
  'PXYZ123': [
    {
      pagerDutyIncidentId: 'INC003',
      pagerDutyServiceId: 'PXYZ123',
      incidentStatusCode: IncidentStatusCode.ONGOING,
      priorityCode: 'P1',
      incidentEnvironmentCode: 'PROD',
      incidentStartDateTime: '2025-10-07T07:45:00Z',
      incidentDescription: 'Database connection timeout causing service disruption',
      serviceIntegrationManagementTicketId: 'SIM-12347',
      incidentCommunicationCounter: 5,
      lastUpdateDateTime: '2025-10-07T10:20:00Z',
      lastUpdatedby: 'gabriel.martin@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: 'a1b2c3d4-e5f6-4789-a0b1-c2d3e4f5g6h7'
        },
        {
          applicationId: 'b2c3d4e5-f6g7-4890-b1c2-d3e4f5g6h7i8'
        }
      ]
    }
  ],
  'ABCD1234': [
    {
      pagerDutyIncidentId: 'INC004',
      pagerDutyServiceId: 'ABCD1234',
      incidentStatusCode: IncidentStatusCode.ONGOING,
      priorityCode: 'P3',
      incidentEnvironmentCode: 'UATM',
      incidentStartDateTime: '2025-11-08T11:20:00Z',
      incidentDescription: 'Intermittent API response delays in reporting module Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud ex',
      serviceIntegrationManagementTicketId: 'SIM-12348',
      jiraTicketKey: 'JIRA-4567',
      ongoingActionsDescription: 'We gonna do things',
      workaroundDescription: 'Those things are gonna be done',
      technicalInformationDescripion: 'Too complex to explain to a simple mortal',
      rootCauseDescription: 'Gabriel was the root cause',
      impactedUserDescription: 'All users are impacted',
      incidentEndDateTime: '2025-12-08T11:20:00Z',
      incidentCommunicationCounter: 2,
      lastUpdateDateTime: '2025-11-09T08:15:00Z',
      lastUpdatedby: 'gabriel.martin@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: 'Example1-Api'
        }
      ]
    },
    {
      pagerDutyIncidentId: 'INC005',
      pagerDutyServiceId: 'ABCD1234',
      incidentStatusCode: IncidentStatusCode.RESOLVED,
      priorityCode: 'P2',
      incidentEnvironmentCode: 'INT',
      incidentStartDateTime: '2025-12-09T14:30:00Z',
      incidentDescription: 'Email notification service failure - Now resolved',
      serviceIntegrationManagementTicketId: 'SIM-12349',
      incidentCommunicationCounter: 4,
      lastUpdateDateTime: '2025-12-10T09:00:00Z',
      lastUpdatedby: 'john.doe@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: 'Example2-api'
        }
      ]
    }
  ]
};

export const MOCK_INCIDENTS_PAGE_1: Record<string, Incident[]> = {
  'PB9SE6X': [
    {
      pagerDutyIncidentId: 'INC001',
      pagerDutyServiceId: 'PB9SE6X',
      incidentStatusCode: IncidentStatusCode.ONGOING,
      priorityCode: 'P1',
      incidentEnvironmentCode: 'PROD',
      incidentStartDateTime: '2025-08-06T08:30:00Z',
      incidentDescription: 'Critical service outage affecting AVC View application',
      serviceIntegrationManagementTicketId: 'SIM-12345',
      incidentCommunicationCounter: 3,
      lastUpdateDateTime: '2025-08-06T09:45:00Z',
      lastUpdatedby: 'john.doe@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: '4f086099-caed-464e-95ab-2ac1189c89e9'
        }
      ]
    },
    {
      pagerDutyIncidentId: 'INC002',
      pagerDutyServiceId: 'PB9SE6X',
      incidentStatusCode: IncidentStatusCode.ONGOING,
      priorityCode: 'P2',
      incidentEnvironmentCode: 'UATR',
      incidentStartDateTime: '2025-09-07T10:15:00Z',
      incidentDescription: 'Performance degradation in authentication service',
      serviceIntegrationManagementTicketId: 'SIM-12346',
      incidentCommunicationCounter: 1,
      lastUpdateDateTime: '2025-09-07T11:00:00Z',
      lastUpdatedby: 'jane.smith@eulerhermes.com',
      impactedApplications: [
        {
          applicationId: '4f086099-caed-464e-95ab-2ac1189c89e9'
        }
      ]
    }
  ],
  'PXYZ123': [
    {
      pagerDutyIncidentId: 'INC003',
      pagerDutyServiceId: 'PXYZ123',
      incidentStatusCode: IncidentStatusCode.CLOSED,
      priorityCode: 'P1',
      incidentEnvironmentCode: 'PROD',
      incidentStartDateTime: '2025-10-07T07:45:00Z',
      incidentDescription: 'Database connection timeout causing service disruption',
      serviceIntegrationManagementTicketId: 'SIM-12347',
      incidentCommunicationCounter: 5,
      resolutionCommunicationSentDateTime: '2026-02-04T06:30:00.000Z',
      lastUpdateDateTime: '2025-10-08T12:00:00Z',
      lastUpdatedby: 'gabriel.martin@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: 'a1b2c3d4-e5f6-4789-a0b1-c2d3e4f5g6h7'
        },
        {
          applicationId: 'b2c3d4e5-f6g7-4890-b1c2-d3e4f5g6h7i8'
        }
      ]
    }
  ],
  'ABCD1234': [
    {
      pagerDutyIncidentId: 'INC004',
      pagerDutyServiceId: 'ABCD1234',
      incidentStatusCode: IncidentStatusCode.OPEN,
      priorityCode: 'P4',
      incidentEnvironmentCode: 'UATM',
      incidentStartDateTime: '2025-11-08T11:20:00Z',
      incidentDescription: 'Intermittent API response delays in reporting module Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud ex',
      serviceIntegrationManagementTicketId: 'SIM-12348',
      jiraTicketKey: 'JIRA-4567',
      ongoingActionsDescription: 'We gonna do things',
      workaroundDescription: 'Those things are gonna be done',
      technicalInformationDescripion: 'Too complex to explain to a simple mortal',
      rootCauseDescription: 'Gabriel was the root cause',
      impactedUserDescription: 'All users are impacted',
      incidentEndDateTime: '2025-12-08T11:20:00Z',
      incidentCommunicationCounter: 2,
      lastUpdateDateTime: '2025-11-09T08:15:00Z',
      lastUpdatedby: 'gabriel.martin@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: 'Example1-Api'
        }
      ]
    },
    {
      pagerDutyIncidentId: 'INC005',
      pagerDutyServiceId: 'ABCD1234',
      incidentStatusCode: IncidentStatusCode.RESOLVED,
      priorityCode: 'P2',
      incidentEnvironmentCode: 'INT',
      incidentStartDateTime: '2025-12-09T14:30:00Z',
      incidentDescription: 'Email notification service failure - Now resolved',
      serviceIntegrationManagementTicketId: 'SIM-12349',
      incidentCommunicationCounter: 4,
      lastUpdateDateTime: '2025-12-10T09:00:00Z',
      lastUpdatedby: 'john.doe@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: 'Example2-api'
        }
      ]
    }
  ]
};

export const MOCK_INCIDENTS_PAGE_2: Record<string, Incident[]> = {
  'PB9SE6X': [
    {
      pagerDutyIncidentId: 'INC005',
      pagerDutyServiceId: 'PB9SE6X',
      incidentStatusCode: IncidentStatusCode.OPEN,
      priorityCode: 'P1',
      incidentEnvironmentCode: 'INT',
      incidentStartDateTime: '2025-08-06T08:30:00Z',
      incidentDescription: 'Critical service outage affecting AVC View application',
      serviceIntegrationManagementTicketId: 'SIM-12345',
      incidentCommunicationCounter: 3,
      lastUpdateDateTime: '2025-08-07T14:30:00Z',
      lastUpdatedby: 'jane.smith@eulerhermes.com',
      impactedApplications: [
        {
          applicationId: '4f086099-caed-464e-95ab-2ac1189c89e9'
        }
      ]
    },
    {
      pagerDutyIncidentId: 'INC006',
      pagerDutyServiceId: 'PB9SE6X',
      incidentStatusCode: IncidentStatusCode.OPEN,
      priorityCode: 'P2',
      incidentEnvironmentCode: 'DEV02',
      incidentStartDateTime: '2025-09-07T10:15:00Z',
      incidentDescription: 'Performance degradation in authentication service',
      serviceIntegrationManagementTicketId: 'SIM-12346',
      incidentCommunicationCounter: 1,
      lastUpdateDateTime: '2025-09-08T08:45:00Z',
      lastUpdatedby: 'john.doe@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: '4f086099-caed-464e-95ab-2ac1189c89e9'
        }
      ]
    }
  ],
  'PXYZ123': [
    {
      pagerDutyIncidentId: 'INC007',
      pagerDutyServiceId: 'PXYZ123',
      incidentStatusCode: IncidentStatusCode.CLOSED,
      priorityCode: 'P1',
      incidentEnvironmentCode: 'UATR',
      incidentStartDateTime: '2025-10-07T07:45:00Z',
      incidentDescription: 'Database connection timeout causing service disruption',
      serviceIntegrationManagementTicketId: 'SIM-12347',
      incidentCommunicationCounter: 5,
      resolutionCommunicationSentDateTime: '2026-02-03T18:45:00.000Z',
      lastUpdateDateTime: '2025-10-09T15:10:00Z',
      lastUpdatedby: 'gabriel.martin@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: 'a1b2c3d4-e5f6-4789-a0b1-c2d3e4f5g6h7'
        },
        {
          applicationId: 'b2c3d4e5-f6g7-4890-b1c2-d3e4f5g6h7i8'
        }
      ]
    }
  ],
  'ABCD1234': [
    {
      pagerDutyIncidentId: 'INC008',
      pagerDutyServiceId: 'ABCD1234',
      incidentStatusCode: IncidentStatusCode.ONGOING,
      priorityCode: 'P3',
      incidentEnvironmentCode: 'PROD',
      incidentStartDateTime: '2025-11-08T11:20:00Z',
      incidentDescription: 'Intermittent API response delays in reporting module Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud ex',
      serviceIntegrationManagementTicketId: 'SIM-12348',
      jiraTicketKey: 'JIRA-4567',
      ongoingActionsDescription: 'We gonna do things',
      workaroundDescription: 'Those things are gonna be done',
      technicalInformationDescripion: 'Too complex to explain to a simple mortal',
      rootCauseDescription: 'Gabriel was the root cause',
      impactedUserDescription: 'All users are impacted',
      incidentEndDateTime: '2025-12-08T11:20:00Z',
      incidentCommunicationCounter: 2,
      lastUpdateDateTime: '2025-11-10T16:00:00Z',
      lastUpdatedby: 'gabriel.martin@allianz-trade.com',
      impactedApplications: [
        {
          applicationId: 'Example1-Api'
        }
      ]
    },
    {
      pagerDutyIncidentId: 'INC009',
      pagerDutyServiceId: 'ABCD1234',
      incidentStatusCode: IncidentStatusCode.RESOLVED,
      priorityCode: 'P2',
      incidentEnvironmentCode: 'DITR',
      incidentStartDateTime: '2025-12-09T14:30:00Z',
      incidentDescription: 'Email notification service failure - Now resolved',
      serviceIntegrationManagementTicketId: 'SIM-12349',
      incidentCommunicationCounter: 4,
      lastUpdateDateTime: '2025-12-11T10:30:00Z',
      lastUpdatedby: 'jane.smith@eulerhermes.com',
      impactedApplications: [
        {
          applicationId: 'Example2-api'
        }
      ]
    }
  ]
};

export const MOCK_PAGINATED_RESPONSE_1:MockPaginatedResponse = {
  pageId: "page1",
  items: Object.values(MOCK_INCIDENTS_PAGE_1).flat(),
  nextPageToken: "page2"
}

export const MOCK_PAGINATED_RESPONSE_2: MockPaginatedResponse = {
  pageId: "page2",
  items: Object.values(MOCK_INCIDENTS_PAGE_2).flat(),
  nextPageToken: undefined
}

export const MOCK_PAGINATED_RESPONSES = [
  MOCK_PAGINATED_RESPONSE_1, MOCK_PAGINATED_RESPONSE_2
]

